import axios from 'axios';
import authService from './authService';
import { getCurrentConfig } from '../config/environmentConfig';

class FlyshieldCatalogService {
  // Retorna o objeto de autorização do usuário (cru, sem envelope BaseResponse):
  // { userId, userName, email, authorizedCompanies: [...] | null }.
  async getUserAuthorization(email) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentConfig();

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/users/authorization/email/${encodeURIComponent(email)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  // Retorna o array de armadilhas (envelopado em BaseResponse), filtrado
  // pelos parâmetros definidos: unit (companyUnitId), farm (companyFarmId),
  // section (trickSectionFieldId).
  async getFlyTrapsBySection({ unit, farm, section } = {}) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentConfig();

    const params = {};
    if (unit !== undefined && unit !== null && unit !== '') params.unit = unit;
    if (farm !== undefined && farm !== null && farm !== '') params.farm = farm;
    if (section !== undefined && section !== null && section !== '') params.section = section;

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/flytraps`,
        {
          params,
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }
}

export default new FlyshieldCatalogService();
